
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/terms-of-use",
      function () {
        return require("private-next-pages/legal/terms-of-use.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/terms-of-use"])
      });
    }
  